//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';

export default {
    name: "AppSearchBar",
    computed: {
        ...mapGetters(['getQueryText']),
        queryText: {
            get() {
                return this.getQueryText;
            },
            set(value) {
                this.textChanged(value);
            }
        }
    },
    methods: {
        ...mapActions(['setQueryText']),
        textChanged: function(text) {
            this.setQueryText(text);
        },
        submit: function() {

        }
    },
    mounted() {
        var tips = document.querySelector(".search-tips");
        const trigger = document.querySelector(".search-tips__trigger");
        const dropdown = document.querySelector(".search-tips__dropdown");
        const close = document.querySelector(".search-tips__close");
        trigger.addEventListener("click", (e) => {
            e.preventDefault();
            const first = dropdown.offsetHeight;
            tips.classList.add("search-tips--active");
            const last = dropdown.offsetHeight;
            dropdown.animate([
                {height: first + 'px'},
                {height: last + 'px'}
            ], {
                easing: 'ease',
                duration: 350
            });
        });
        close.addEventListener("click", () => {
            tips.classList.remove("search-tips--active");
            trigger.focus();
        });
    }
};
